/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-09 09:49:13
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-24 19:37:52
 */
import React from "react";

export default function Avatar({ username, size, fontSize }: { username: string; size: string; fontSize: string }) {
	const style: React.CSSProperties = {
		display: "inline-block",
		width: size,
		height: size,
		borderRadius: "50%",
		backgroundColor: "#565BDD",
		fontSize: fontSize,
		color: "#FFFFFF",
		textAlign: "center",
		lineHeight: size
	};

	return <span style={style}>{username && username?.[0]?.toUpperCase()}</span>;
}
